var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.768 5.44871C18.3665 4.81329 18.8229 4.07521 19.111 3.27687C19.399 2.47853 19.5129 1.63565 19.4463 0.796631C17.6086 0.933258 15.9028 1.72932 14.6963 3.0133C14.1185 3.62868 13.6807 4.34458 13.4087 5.11861C13.1368 5.89264 13.0362 6.70907 13.113 7.51955C14.0094 7.52643 14.8954 7.34323 15.7027 6.98413C16.5099 6.62504 17.2165 6.09968 17.768 5.44871ZM21.758 16.2987C21.7686 15.1812 22.0882 14.0847 22.6865 13.1126C23.2849 12.1404 24.1424 11.3247 25.178 10.7425C24.5244 9.8751 23.6604 9.15993 22.6545 8.65366C21.6486 8.14738 20.5285 7.86394 19.383 7.8258C16.913 7.59246 14.633 9.15288 13.3188 9.15288C12.0046 9.15288 10.1521 7.85496 8.09379 7.88413C6.74816 7.92496 5.43699 8.28631 4.28817 8.93294C3.13934 9.57958 2.19209 10.4894 1.53879 11.5737C-1.24788 16.0362 0.826291 22.6716 3.61296 26.2737C4.87962 28.0383 6.46296 30.0362 8.55296 29.9633C10.643 29.8904 11.3238 28.7675 13.7463 28.7675C16.1688 28.7675 16.913 29.9633 18.9713 29.9195C21.0296 29.8758 22.4863 28.1112 23.8163 26.3466C24.7584 25.0655 25.4944 23.6656 26.0013 22.1904C24.7465 21.6975 23.6759 20.8768 22.9218 19.8298C22.1677 18.7827 21.7631 17.5552 21.758 16.2987Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.063c6c870f718a772366ae41ab0868a3.svg";
export { ForwardRef as ReactComponent };